import React from "react";
import UserTable from "./components/UserTable";

const UserTableContainer = () => <UserTable />;

export default UserTableContainer;